import script from "./CalendarGridBody.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarGridBody.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__